/* @flow strict */

import * as React from 'react';
import { Link, withRouter } from 'react-router-dom';
import NavbarTitleBackAction from '/client/src/components/topNavbar/backAction';
import IntegrationsWidgetEmbed from './embed';

import './styles.scss';

type PropsType = {
  match: {
    params: {
      viewTab?: string
    }
  }
};

const items = [
  {
    link: '',
    label: 'Embed'
  }
];

const IntegrationsWidget = ({ match }: PropsType): React.Element<'div'> => {
  const { params: { viewTab } } = match;
  const _viewTab = viewTab ? viewTab.toLowerCase() : '';
  const menuItems = items.map((i: {}, k: number): React.Element<'li'> => {
    return (
      <li
        key={`IntegrationsWidget-menuItems-${k}`}
        className={`${(_viewTab) === i.link ? 'active' : ''}`}
      >
        <Link to={`/integrations/widget/${i.link}`}>
          {i.label}
        </Link>
      </li>
    );
  });

  return (
    <div className='IntegrationsWidget'>
      <NavbarTitleBackAction />

      <div className="sparxo-router-content">
        <div className="sparxo-page-container">
          <div className="event-list">
            <div className="facebook-page">
              <div className="sparxo-integrations-cards">
                <div className="sparxo-integrations-list" style={{ marginTop: 0 }}>
                  <div
                    className="sparxo-integrations-item"
                    style={{
                      background: 'none',
                      maxWidth: '530px',
                      margin: '0 auto'
                    }}
                  >
                    <div className="media">
                      <div className="media-left">
                        <img src="https://nest.sparxo.com/public/integrations/code.png" alt="cards" className="media-object"/>
                      </div>

                      <div className="media-body">
                        <h4 className="media-heading" style={{ fontWeight: 0 }}>
                          Ticket holder login widget
                        </h4>

                        <span>Allow your customer to manage their tickets from your website</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="panel panel-default panel-page">
                <div className="navbar-page-toolbar customers-navbar code-navbar">
                  <div className="container-fluid" style={{ height: '50px' }}>
                    <ul className="nav">
                      {menuItems}
                    </ul>
                  </div>
                </div>

              </div>

              {!viewTab ?
                <IntegrationsWidgetEmbed/> : null
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(IntegrationsWidget);
